module.exports = __webpack_public_path__ + "img/電気回路_3_10_1.131da5db.png";